/**
 * 🎪 **아이 화면에 보이는 행사를 지우려 하나** (2026-10-13).
 *
 * 행사 저장은 목록 통째로 바꾸기다. 진행 중·다가오는 행사를 지우고 저장하면 메인 배너·[커뮤니티]·무대에서
 * 묻지 않고 사라진다(지도·QR·랠리와 같은 모양). 행사엔 고정 id 가 없어 저장 직전 견주기 대신 **지우는 순간** 묻는다.
 * 꺼 둔 행사·끝난 행사는 묻지 않는다 — 아이 화면이 바뀌지 않는다.
 */
export interface EventLike {
  title: string;
  end?: string;
  start?: string;
  visible?: boolean;
}

export function eventRemoveWarning(e: EventLike, nowMs: number): string | null {
  if (e.visible === false) return null; // 없으면 보이는 것(EventDoc 주석)
  if (!e.title.trim()) return null; // 제목 없는 줄은 원래 저장되지 않는다
  const end = e.end ? Date.parse(e.end) : Number.NaN;
  if (Number.isFinite(end) && end < nowMs) return null; // 이미 끝났다
  const start = e.start ? Date.parse(e.start) : Number.NaN;
  const when = Number.isFinite(start) && start > nowMs ? "다가오는 행사" : "지금 아이 화면에 보이는 행사";
  return `「${e.title.trim()}」은(는) ${when}예요. 지우고 저장하면 메인 배너·[커뮤니티]·무대에서 바로 사라져요. 지울까요? (잠깐 숨기려면 [아이 화면에 보이기]를 끄세요)`;
}
